export const usersHeadersData = [
  { text: 'Avatar', value: 'userInfo.avatar', sortable: false, class: '' },
  { text: 'Email', value: 'username', sortable: true, class: '' },
  { text: 'Date Installed', value: 'created', sortable: true, class: '' },
  { text: 'Platform', value: 'platform', sortable: false, class: '' },
  { text: 'Country', value: 'userInfo.country', sortable: false, class: '' },
  { text: 'About Me', value: 'userInfo.description', sortable: false, class: '' },
  { text: 'Interested In', value: 'userInfo.interests', sortable: false, class: '' },
];
